import { Component, OnInit, ViewContainerRef, viewChild } from '@angular/core';
import { Modal } from '../../modal';
import { showHide } from '../../modal-animations';

@Component({
    selector: 'app-modal-template-border-image',
    templateUrl: './modal-template-border-image.component.html',
    styleUrls: ['./modal-template-border-image.component.scss'],
    animations: [showHide],
    standalone: false
})
export class ModalTemplateBorderImageComponent extends Modal implements OnInit {

  readonly contentRef = viewChild('content', { read: ViewContainerRef });

  constructor() {
    super();
  }

  ngOnInit() {

  }

}
